'use strict';

angular.module('app')
  .directive('focusOnClick', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        element.on('click', function() {
            if (element.attr('readonly') || element.hasClass('delimeter')) {
                document.getElementById('exp-month').focus()
            }
        });
      }
    };
  });